var resultsCountToken = '{resultsCount}';
var resultsCountDictionaryKey = 'SearchResultsTotalCount';
var SearchResultsCountController = (function () {
    function SearchResultsCountController(dictionary) {
        var _this = this;
        this.dictionary = dictionary;
        this.translationFormat = '';
        this.dictionary
            .get(resultsCountDictionaryKey)
            .then(function (translation) { return _this.translationFormat = translation; });
    }
    Object.defineProperty(SearchResultsCountController.prototype, "resultsCount", {
        get: function () {
            return this.solutions
                .map(function (f) { return f.groups.length; })
                .reduce(function (previous, current) { return previous + current; }, 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SearchResultsCountController.prototype, "message", {
        get: function () {
            return this.translationFormat.replace(resultsCountToken, String(this.resultsCount));
        },
        enumerable: false,
        configurable: true
    });
    SearchResultsCountController.$inject = ['contentDictionary'];
    return SearchResultsCountController;
}());
export var SearchResultsCountComponent = {
    bindings: {
        solutions: '<',
    },
    controller: SearchResultsCountController,
    template: "\n    <div class=\"search-result-count\" ng-bind=\"$ctrl.message\"></div>\n  ",
};
